import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const assetsDashboardsRoute: InvariantJiraRoute = {
	name: 'assets-dashboards',
	path: '/jira/assets/dashboards',
	exact: true,
};
